// extracted by mini-css-extract-plugin
export var card = "_sg-0";